import React from "react";
import ContactForm from "./components/ContactForm";
import PageTitle from "../../Shared/PageTitle/PageTitle";

import "./Contact.css";

const Contact = () => {
  return (
    <>
      <PageTitle title={"Contact"} currentPage={"Contact"} />
      <section className="wpo-contact-pg-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-lg-10 offset-lg-1">
              <div className="office-info">
                <div className="row">
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-location"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Adresse</h2>
                        <p>Route de Sousse km4 2014 Megrine Riadh, BP 62</p>
                      </div>
                    </div>
                  </div>
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-email"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Email</h2>
                        <p style={{ margin: "1.66rem" }}>
                          commercial@semat.com.tn
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-telephone"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Telephone</h2>
                        <p>
                          <a href="tel:71392216">+ (216) 71 392 216</a>
                        </p>
                        <p>
                          <a href="tel:25443300">+ (216) 25 443 300</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="wpo-contact-title">
                <h2>Envoyez-nous votre message</h2>
                <p>Contactez nous pour tous renseignements.</p>
              </div>
              <div className="wpo-contact-form-area">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
        <div className="wpo-contact-map-section">
          <div className="wpo-contact-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3195.9929960531363!2d10.207848851079682!3d36.77073547985627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd372cf8a6d1d1%3A0x9c245929e7db3a63!2sSte%20%C3%A9quipement%20et%20mat%C3%A9riel!5e0!3m2!1sen!2stn!4v1649976345059!5m2!1sen!2stn"></iframe>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
